import AuthManagerBase from "@lib/apitools/AuthManagerBase";
import Keycloak, {KeycloakProfile} from "keycloak-js";

type TokenResponse = {
    access_token: string
    refresh_token: string
    expires_in: number
}

type UserDataResponse = {
    role: string
    is_admin: boolean
}

type AllMyDataResponse = {
    role: string
    is_admin: boolean
    data: object
}

type ErrorResponse = {
    error: boolean
    detail: string
}

function empty(str: string): boolean {
    if(!str) return true;
    str = str.trim().toLowerCase();
    return !str || str == "0" || str == "false";
}
/**
 * AuthManager implementation based on bearer token, with refresh token.
 * Auth info is stored in cookies.
 */

class AuthManager<
    Credentials extends object,
    UserData extends object
> extends AuthManagerBase {
    private _keycloak: Keycloak;
    private _refreshPeriod = 240000;
    private _redirectUrl: string;
    private _realm: string;

    constructor (url: string, client: {id: string, realm: string}, redirectUrl: string) {
        super();
        this._keycloak = new Keycloak({
            url,
            realm: client.realm,
            clientId: client.id
        },);
        this._redirectUrl = redirectUrl;
        this._realm = client.realm;
        this._clientID = client.id;
        this._keycloakUrl = url;
    }
    
    getMyData(): Promise<AllMyDataResponse> {
        return Promise.resolve({});
    }

    authOpts(opts: RequestInit): RequestInit {
        return {
            ...opts,
            headers: {
                Authorization: `Bearer ` + this._keycloak.token,
                Realm: this._realm,
                Accept: "application/json",
                ...(opts.headers??{})
            },
        };
    }

    login(credentials: Credentials): Promise<KeycloakProfile> {
        return this._keycloak.login({
            redirectUri: this._redirectUrl,  
        });
    }

    auth(): Promise<KeycloakProfile> {
        return this._keycloak.init({
              redirectUri: this._redirectUrl,   
             checkLoginIframe: false,
             onLoad: 'login-required'
        }).then(res => {
            if(!res)
                return this._keycloak.login({
                    redirectUri: this._redirectUrl,  
                }).then(d => {
                    this._setCookie();
                    return d;
                });
        })
        .catch(e => {
            console.error(e);
        })  
            .then(() => this.setAutoRefresh())
            .then(() => {
                const d = this.tokenParsed;
                this._setCookie();                
                return {
                    ...d,
                    username: this.tokenParsed.preferred_username,
                }
            });;
    }

    setAutoRefresh() {
        console.log("REFRESH IN", this._refreshPeriod)
        if(this._timer) clearInterval(this._timer);

        this._timer = setTimeout(() => {
            this.refresh().then(() => {
                this._timer = null;
                this.setAutoRefresh();
            });           
        }, this._refreshPeriod);
    }

    get tokenParsed() {
        return this._keycloak.tokenParsed || {};
    }


    getUserData() {
        console.log(this.tokenParsed)
        return Promise.resolve(({
            ...this.tokenParsed,
            username: this.tokenParsed?.preferred_username,
            roles: this.tokenParsed?.realm_access?.roles,
            clientRoles: this.tokenParsed?.client_roles,
        }));
    }

    getAccessToken() {
        return Promise.resolve(this._keycloak.token);
    }

    refresh(): Promise<boolean> {
        console.log("Refresh token")

        return this._keycloak.updateToken(90)
            .then((t) => {
                this._setCookie();
                return t;
            });
    }
    _setCookie() {
        const date = new Date();
        date.setTime(date.getTime() + this._refreshPeriod * 2);
        const expiration = "; expires=" + date.toUTCString();
        document.cookie = "token=Bearer " + this.token + expiration  
        document.cookie = "realm=" + this._realm + expiration;
    }
    logout() {
        return this._keycloak.logout();
    }
    get token() {
        return this._keycloak.token;
    }
}

export default AuthManager;